import "./ServiciosIA.module.css";
import Header from "@/reusable_sections/Header";
import IntroducciN from "./sections/IntroducciN";
import PerdidasEmpresariales from "./sections/PerdidasEmpresariales";
import ResultadosAntesDespues from "./sections/ResultadosAntesDespues";
import ServiciosClave from "./sections/ServiciosClave";
import CMoFuncionaElProceso from "./sections/CMoFuncionaElProceso";
import Usageexamples from "./sections/Usageexamples";
import PorQueAvtecsa from "./sections/PorQueAvtecsa";
import ContactAndNextSteps from "./sections/ContactAndNextSteps";
import Footer from "@/reusable_sections/Footer";
export default function ServiciosIAPage() {
  return <div>
      <Header />
      <IntroducciN />
      <PerdidasEmpresariales />
      <ResultadosAntesDespues />
      <ServiciosClave />
      <CMoFuncionaElProceso />
      <Usageexamples />
      <PorQueAvtecsa />
      <ContactAndNextSteps />
      <Footer />
    </div>;
}